import React, { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { RoutePaths } from "../enumStrings";

const Sample = (): ReactElement => {
  const navigate = useNavigate();

  return (
    <div className="py-4">
      {/* <p>Sample content goes here</p>
      <div className="mt-4 space-x-2">
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => navigate("/fff")}
        >
          Test Navigation
        </button>
        <button
          className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
          onClick={() => navigate(RoutePaths.logout)}
        >
          Logout
        </button>
      </div> */}
    </div>
  );
};

export default Sample;
